// Texto 26 (B3/B4, REGRAS 2.3 e 3.5): deslizar dentro de uma caixa é do ITEM (excluir / duplicar) ou não faz nada
// (dentro de um bloco de texto). Quem envolve o item marca o toque; o cartão de fora (AcoesItem, SwipeDuplo)
// vê a marca e não "pega" o deslizar.
let interno = false;
/** O cartão de fora chama no começo de cada toque (fase de captura, de fora para dentro): zera a marca. */
export const zerarToqueInterno = () => { interno = false; return false; };
/** O item de dentro chama no começo do toque (depois do cartão de fora): o deslizar é dele. */
export const marcarToqueInterno = () => { interno = true; return false; };
export const toqueInterno = () => interno;

/** Texto 28 (A5, REGRAS 0.5): o dedo foi para o lado (mesmo meio inclinado). Antes só valia com o dedo quase reto
 *  (2× mais para o lado que para baixo): inclinado, a tela rolava e o cartão não deslizava. */
export const paraOLado = (g: { dx: number; dy: number }, min = 10) => Math.abs(g.dx) > min && Math.abs(g.dx) >= Math.abs(g.dy);
